<template>
  <div>
    <section ref="seccionLluvia" class="lluvia-sobres">
      <div class="contenido">
        <h2 ref="tituloRef" class="titulo">
          <span class="serif">Lluvia de</span><br />
          <span class="script">Sobres</span>
        </h2>

        <p ref="textoRef" class="texto">
          Tu presencia es el regalo más valioso para mí. ✨   <br>
      Pero si deseas tener un tetalle, lo recibire con mucho aprecio y profunda gratitud. 
        </p>

        <img ref="sobreRef" :src="sobrePng" class="icono-sobre" alt="Sobre" />

        <p ref="lluviaTextoRef" class="lluvia-texto"></p>

        <p ref="graciasRef" class="gracias">¡GRACIAS!</p>
      </div>

      <div ref="lluviaIzq" class="lluvia lluvia-izq" aria-hidden="true"></div>
      <div ref="lluviaDer" class="lluvia lluvia-der" aria-hidden="true"></div>
    </section>

  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import sobrePng from '@/assets/ss.png'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'LluviaDeSobres',
  setup() {
    // Refs principales renombradas para aislamiento estricto y seguro
    const seccionLluvia = ref(null)
    const seccionNinos = ref(null)

    // Refs de elementos internos del DOM
    const tituloRef = ref(null)
    const textoRef = ref(null)
    const sobreRef = ref(null)
    const lluviaTextoRef = ref(null)
    const graciasRef = ref(null)
    const tituloNinosRef = ref(null)
    const textoNinosRef = ref(null)
    const graciasNinosRef = ref(null)

    // Contenedores para efectos de lluvia
    const lluviaIzq = ref(null)
    const lluviaDer = ref(null)
    const lluviaNinosIzq = ref(null)
    const lluviaNinosDer = ref(null)

    let ctx1; // Contexto GSAP para Bloque 1
    let ctx2; // Contexto GSAP para Bloque 2

    const crearLluvia = (contenedorEl, lado = 'der', cantidad = 12) => {
      if (!contenedorEl) return
      
      // Limpiamos los sobres antiguos antes de generar nuevos para evitar duplicaciones infinitas al hacer scroll back
      contenedorEl.innerHTML = ''

      for (let i = 0; i < cantidad; i++) {
        const el = document.createElement('img')
        el.src = sobrePng
        el.className = 'sobre-lluvia'
        el.style.position = 'absolute'
        el.style.width = '35px' // Un pelín más pequeño optimizado para móvil
        el.style.pointerEvents = 'none' // Evita interferir con los toques del usuario
        contenedorEl.appendChild(el)

        const rndDelay = gsap.utils.random(0, 0.6)
        const rndDur = gsap.utils.random(1.8, 2.5) // Caída ligeramente más rápida y vistosa
        const xStart = lado === 'der' ? 110 : -30
        const xEnd = lado === 'der' ? -40 : 120

        gsap.fromTo(el,
          { 
            xPercent: xStart, 
            yPercent: -30, 
            rotate: gsap.utils.random(-40, 40), 
            opacity: 0, 
            scale: 0.3 
          },
          {
            xPercent: xEnd,
            yPercent: 140,
            rotate: gsap.utils.random(120, 360),
            opacity: 0.9,
            scale: gsap.utils.random(0.5, 0.8),
            duration: rndDur,
            delay: rndDelay,
            ease: 'power1.out', // Una caída suave pero decidida
            onComplete: () => el.remove()
          }
        )
      }
    }

    onMounted(async () => {
      await nextTick()

      // --- ANIMACIÓN BLOQUE 1 (Sobres físicos) ---
      if (seccionLluvia.value) {
        ctx1 = gsap.context(() => {
          const $1 = gsap.utils.selector(seccionLluvia.value)
          
          const tl1 = gsap.timeline({
            scrollTrigger: {
              trigger: seccionLluvia.value,
              start: "top 70%", // Espera a que el bloque esté bien adentro de la pantalla en móvil
              toggleActions: "play none none reverse"
            }
          })

          const subTitulos = $1('.serif, .script')
          if (subTitulos.length) {
            tl1.fromTo(subTitulos, 
              { y: 40, opacity: 0 }, 
              { y: 0, opacity: 1, duration: 0.7, stagger: 0.15, ease: "back.out(1.4)" }
            )
          }

          tl1.fromTo(textoRef.value, { opacity: 0, y: 25 }, { opacity: 1, y: 0, duration: 0.5 }, "-=0.4")
             .fromTo(sobreRef.value, { scale: 0, rotation: -35, opacity: 0 }, { scale: 1, rotation: 0, opacity: 1, duration: 0.7, ease: "elastic.out(1, 0.75)" }, "-=0.3")
             .fromTo(lluviaTextoRef.value, { opacity: 0, y: 15 }, { opacity: 1, y: 0, duration: 0.4 }, "-=0.4")
             .fromTo(graciasRef.value, { opacity: 0, y: 15 }, { opacity: 1, y: 0, duration: 0.4 }, "-=0.3")
             .add(() => {
               crearLluvia(lluviaDer.value, 'der', 10)
               crearLluvia(lluviaIzq.value, 'izq', 10)
             }, "-=0.3")

        }, seccionLluvia.value)
      }

      // --- ANIMACIÓN BLOQUE 2 (ZELLE / NIÑOS) ---
      if (seccionNinos.value) {
        ctx2 = gsap.context(() => {
          const $2 = gsap.utils.selector(seccionNinos.value)

          const tl2 = gsap.timeline({
            scrollTrigger: {
              trigger: seccionNinos.value,
              start: "top 72%", // Activación idónea para móviles
              toggleActions: "play none none reverse"
            }
          })

          const subTitulosNinos = $2('.serif')
          if (subTitulosNinos.length) {
            tl2.fromTo(subTitulosNinos,
              { x: -40, opacity: 0 },
              { x: 0, opacity: 1, duration: 0.7, ease: "power2.out" }
            )
          }

          tl2.fromTo(textoNinosRef.value, { x: 40, opacity: 0 }, { x: 0, opacity: 1, duration: 0.7, ease: "power2.out" }, "-=0.5")
             .fromTo(graciasNinosRef.value, { opacity: 0, y: 15 }, { opacity: 1, y: 0, duration: 0.4 }, "-=0.3")
             .add(() => {
               crearLluvia(lluviaNinosDer.value, 'der', 8)
               crearLluvia(lluviaNinosIzq.value, 'izq', 8)
             }, "-=0.4")

        }, seccionNinos.value)
      }
    })

    onUnmounted(() => {
      // Destruye limpiamente animaciones y ScrollTriggers de ambos contextos sin dejar rastro en memoria
      if (ctx1) ctx1.revert()
      if (ctx2) ctx2.revert()
    })

    return {
      seccionLluvia, seccionNinos,
      tituloRef, textoRef, sobreRef, lluviaTextoRef, graciasRef,
      tituloNinosRef, textoNinosRef, graciasNinosRef,
    
      sobrePng
    }
  }
}
</script>


<style scoped>
.lluvia-sobres{
  position: relative;
  max-width: 520px;
  margin: 0 auto;
  padding: 48px 20px 56px;
  text-align: center;
  background:
    linear-gradient(
       rgba(224, 165, 170, 0.705),
      rgba(236, 192, 191, 0.705)
    ),
    url('@/assets/fn.avif') center center / cover no-repeat;overflow: hidden;
}
.contenido{ position: relative; z-index: 2;  }

.titulo{
  margin: 0 0 10px;
  color: #fff;
  line-height: 1.05;
}
.titulo .serif{
  font-family: 'britishgruesa', serif;
  font-size: 56px;
  display: inline-block;
}
.titulo .script{
  font-family: 'nombre', cursive;
  font-size: 44px;
  font-weight: 400;
  display: inline-block;
  opacity: .95;
}

.texto{
  font-family: 'bethany', sans-serif;
  color: #fff;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: 0.03em; /* espaciado suave */
  max-width: 420px;
  margin: 12px auto 18px;
  opacity: .95;
}

.icono-sobre{
  width: 110px;
  height: auto;
  display: block;
  margin: 8px auto 8px;
  filter: drop-shadow(0 6px 12px rgba(0,0,0,.12));
}

.gracias{
  font-family: 'padres', serif;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: .08em;
  font-weight: 800;
  margin: 4px 0 0;
}

.lluvia{
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 1;
}
.lluvia-izq{ left: 0; }
.lluvia-der{ right: 0; }

.sobre-lluvia{
  position: absolute;
  top: -10%;
  left: 0;
  width: 28px;
  height: auto;
  opacity: 0.9;
  filter: drop-shadow(0 4px 8px rgba(0,0,0,.10));
}

@media (max-width: 380px){
  .titulo .serif{ font-size: 50px; }
  .titulo .script{ font-size: 40px; }
  .icono-sobre{ width: 96px; }
}
.lluvia-texto{
  font-family: 'padres', serif;
  font-size: 18px;
  color: #ffffff;
  margin-top: 8px;
  letter-spacing: .05em;
  opacity: .95;
}
</style>
